var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"purple","text":""},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" mdi-arrow-left-thin-circle-outline ")]),_vm._v(" go Back ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }